export default {"src":"/_next/static/media/blog_page.1f307c2d.svg","height":3840,"width":3840};